import { combineReducers } from 'redux';

import { academic } from './academic/academic';
import { kycs } from './kycs/kycs';
import { offers } from './offers/offers';
import { recipient } from './recipient/recipient';
import { sender } from './sender/sender';

const fields = combineReducers({
  kycs,
  offers,
  recipient,
  sender,
  academic,
});

export { fields };
